import React from 'react';
import { getEarningsProgressState } from '../utils/earningsProgress';
import { isUKSeller } from '../utils/sellerRegion';

export default function EarningsProgressTracker({ step, sessionData }) {
  const { milestones, earnedAmount, targetAmount } = getEarningsProgressState({
    step,
    sessionData,
  });

  // Currency follows the seller's country (matches Step21PaymentDetails / Step22):
  // GB → £, everyone else (US) → $. Without this the earnings header showed £ on ~17
  // of 21 steps to US sellers.
  const isUK = isUKSeller(sessionData);
  const symbol = isUK ? '£' : '$';
  const formatAmount = (amount) => `${symbol}${Number(amount || 0).toFixed(2)}`;

  return (
    <section
      className="earnings-tracker"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={targetAmount}
      aria-valuenow={earnedAmount}
      aria-label="Earnings progress"
    >
      <div className="earnings-tracker__title-row">
        <span className="earnings-tracker__title">Your earnings progress</span>
        <span className="earnings-tracker__counter">
          <span className="earnings-tracker__earned">{formatAmount(earnedAmount)}</span>
          <span className="earnings-tracker__target"> / {formatAmount(targetAmount)}</span>
        </span>
      </div>

      <div className="earnings-tracker__milestones">
        {milestones.map((milestone, index) => (
          <React.Fragment key={milestone.id}>
            <div className={`earnings-tracker__coin earnings-tracker__coin--${milestone.state}`}>
              <span aria-hidden="true">{symbol}5</span>
              <span className="earnings-tracker__sr">
                Step {index + 1} of {milestones.length}: {milestone.label}, {milestone.state}
              </span>
            </div>
            {index < milestones.length - 1 && (
              <div
                className={`earnings-tracker__connector earnings-tracker__connector--${connectorState(
                  milestones,
                  index,
                )}`}
                aria-hidden="true"
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}

function connectorState(milestones, index) {
  const left = milestones[index]?.state;
  const right = milestones[index + 1]?.state;
  if (left === 'skipped' || right === 'skipped') return 'skipped';
  if (left === 'earned' && (right === 'earned' || right === 'current')) return 'complete';
  return 'pending';
}
